<template>
  <section class="app-ecommerce-details ">

      <b-row class="pb-2 d-flex justify-content-end mr-1">
        <b-col cols="auto" class="text-right align-self-end">
          <p><strong>Total de Pedidos :</strong> {{ totalUnidades }}</p>
          <p><strong>Total Valor : </strong> R$ {{ totalValor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
        </b-col>
      </b-row>
<!--    <pre>{{ json }}</pre>-->
      <b-row class="ml-1 my-2">

  <b-col cols="1" class="imagens-container pr-0 mt-1">
    <div class="imagens-item">
      <div v-if="json.imagens.length > 0"  v-for="(img, index) in (json.imagens || []).slice(0, 3)"  :key="index">
        <div class="rounded imagens-item-img">
          <b-img
              :src="img.caminho ? img.caminho : imagemPadrao"
              :alt="`${json.item_name}-${json.item_id}`"
              @click="json.item_img_princial = img.caminho"
              class="img-fluid"
              @mouseover="json.item_img_princial = img.caminho"
          />
        </div>
      </div>
      <div v-if="json.imagens.length > 3" class="d-flex justify-content-center align-items-center bg-grey-1 rounded"
           style="border: 1px solid var(--primary); width: 50px; height: 50px;"
           v-b-modal.modal-gallery-imagens>
        +{{ json.imagens.length - 3 }}
      </div>
    </div>
  </b-col>
  <b-col cols="12" sm="12" md="2" class="px-auto mt-1">
    <b-img
        :src="json.item_img_princial ? json.item_img_princial : imagemPadrao"
        :alt="`${json.item_name}-${json.item_id}`"
        style="padding: 0;"
        class="img-fluid"
    />
  </b-col>
  <b-col cols="12" md="6">
    <h4>{{ json.referencia }} - {{ json.item_name }}</h4>
    <b-card-text class="item-company mb-0">
      <span>by </span>
      <b-link class="company-name">{{ json.item_marca }}</b-link>
    </b-card-text>
    <div class="ecommerce-details-item_price d-flex flex-wrap mt-1">
      <h4 class="item-item_price mr-1">R$ {{ json.item_price.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</h4>
    </div>

    <b-card-text  v-if="json.embalagens.length !== 0">Disponível - <span class="text-success">Em estoque</span></b-card-text>
    <!--                  <b-card-text>{{ product.item_caracteristicas }}</b-card-text>-->
    <div v-if="json.embalagens.length === 0">

      <b-alert show variant="danger">
        Não há embalagens disponíveis
      </b-alert>
    </div>
    <div class="product-color-options" v-if="json.embalagens.length !== 0">
      <h6>Embalagem</h6>
      <ul class="list-unstyled mb-0 scrollable-pills" style="
    display: flex;
    gap: 20px;
">
        <li v-for="embalagem in json.embalagens" :key="embalagem.descricao_embalagem" style="display: flex;gap: 10px">
          <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              :variant="formColor.embalagem === embalagem.descricao_embalagem ? 'secondary' : 'outline-secondary'"
              size="sm"
              @click="selectEmbalagem(embalagem)"
          >
            {{ embalagem.descricao_embalagem }}
          </b-button>
        </li>
      </ul>
      <hr>
      <!-- Colors -->
      <div class="product-color-options">
        <h6>Cores</h6>
        <ul class="list-unstyled mb-0 scrollable-pills" style="
          display: flex;
          gap: 20px;
          ">
          <li v-for="color in availableColors" :key="color.cdnCor" style="display: flex;gap: 10px">
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                :variant="formColor.color === color.desCor ? 'secondary' : 'outline-secondary'"
                size="sm"
                @click="selectColor(color)"
            >
              {{ color.desCor }}
            </b-button>
          </li>
        </ul>
      </div>
      <!-- Sizes -->
      <hr>
      <div class="product-color-options">
        <h6>Tamanhos</h6>
        <ul class="list-unstyled mb-0 scrollable-pills" style="
    display: flex;
    gap: 20px;
">
          <li v-for="size in availableSizes" :key="size" style="display: flex;gap: 10px">
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                :variant="formColor.tamanho === size ? 'secondary' : 'outline-secondary'"
                size="sm"
                @click="formColor.tamanho = size"
            >
              {{ sizeLabel(size) }}
            </b-button>
          </li>
        </ul>
      </div>

      <!-- Quantity -->
      <hr>
      <div class="product-color-options">
        <h6>Quantidade</h6>
        <b-form-group>
          <b-input-group style="max-width: 320px;">
            <b-form-input v-model="formColor.quantidade" type="number" min="1" style="border-radius: 20px; margin-right: 1rem;" />
            <b-input-group-append>
              <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" pill @click="repeateAgain">
                Adicionar
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
      <hr>
    </div>
  </b-col>
  <div class="mx-1">
    <div>
      <h3>Itens Selecionados</h3>
    </div>
    <div class="row mt-3" style="gap: 10px">
      <div
          class="col-auto cursor-pointer px-0"
          v-for="(item, index) in items"
          :id="item.item_id"
          :key="item.item_id"
      >
        <b-badge variant="primary" class="d-flex align-items-center">
          <span>{{ item.referencia }} - {{ item.embalagem }} - {{ item.valor }} - {{ item.des_cor }} - {{ item.tamanho }}</span>
          <button type="button" class="close ml-2" @click="removeItem(index, item)">
            <span aria-hidden="true">&times;</span>
          </button>
        </b-badge>
      </div>
    </div>
  </div>
</b-row>
      <b-modal
          id="modal-gallery-imagens"
          hide-footer
          hide-header
          style="height: 500px; width: 100%;background: transparent; border: none; padding: 0; margin: 0;"
          body-bg-variant="transparent"
      >
        <swiper
            ref="refSwiperGallery"
            class="swiper-gallery gallery-top"
            :options="swiperOptions"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        >
          <swiper-slide
              v-for="(data,index) in itemSelected.imagens"
              :key="index"
          >
            <b-img
                :src="data.caminho"
                fluid
            />
          </swiper-slide>

          <div
              slot="button-next"
              class="swiper-button-next swiper-button-white"
          />
          <div
              slot="button-prev"
              class="swiper-button-prev swiper-button-white"
          />
        </swiper>
      </b-modal>

  </section>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BImg, BCardText, BLink, BButton, BDropdown, BDropdownItem, BAlert, BFormGroup, BFormSpinbutton, BBadge, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
import { ref } from '@vue/composition-api';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { mapGetters } from 'vuex';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import ScrollToTop from '@core/components/scroll-to-top/ScrollToTop.vue';
import { IMAGEM_PADRAO } from '@/utils/imagemUrl';
import { carregarTamanhos, descricaoTamanhoGrade } from '@/utils/tamanhos';

export default {
  directives: {
    Ripple,
  },
  components: {
    ScrollToTop,
    BCard,
    SwiperSlide,
    Swiper,
    BCardBody,
    BRow,
    BCol,
    BImg,
    BCardText,
    BLink,
    BButton,
    BDropdown,
    BDropdownItem,
    BAlert,
    BFormGroup,
    BFormSpinbutton,
    BBadge,
    BInputGroup,
    BInputGroupAppend,
  },
  props: {
    json: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      imagemPadrao: IMAGEM_PADRAO,
      formColor: {
        embalagem: '',
        cdn_embalagem: '',
        color: '',
        tamanho: '',
        quantidade: 0,
      },
      items: [

      ],
      availableColors: [],
      availableSizes: [],
      tamanhosMap: {},
      gradeColorSelecionada: null,
      isLoading: true,
      itemSelected: [{
        imagens: [],
      }],
      swiperOptions: {
        loop: true,
        loopedSlides: 5,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 5,
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 4,
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },

    };
  },
  computed: {
    ...mapGetters('intensPedido', [
      'getIsLoadingReferencia',
      'getIsLoadingReferenciaRestante',

    ]),
    totalValor() {
      return this.items.reduce((sum, item) => sum + (parseFloat(this.json.item_price) * item.valor), 0);
    },
    totalUnidades() {
      return this.items.reduce((acc, item) => acc + Number(item.valor), 0);
    },

  },
  mounted() {
    carregarTamanhos().then((tamanhos) => { this.tamanhosMap = tamanhos; });
    console.log('JSON SUBITENS', this.json.subItens);
    this.json.subItens.forEach((subitem) => {
      const newItem = {
        referencia: subitem.familiaComercialId,
        nome: subitem.item_descricao,
        preco: subitem.precoUnitario,
        marca: subitem.marca,
        embalagem: subitem.embalagem || this.formColor.embalagem, // Use the value from subitem if available
        cdn_embalagem: subitem.cdn_embalagem || this.formColor.cdn_embalagem,
        des_cor: subitem.des_cor,
        cdn_cor: subitem.cdncor, // Use cdnCor found in the JSON or from subitem
        tamanho: subitem.desc_tamanho,
        item_id: subitem[`item${subitem.desc_tamanho}`], // Use cdn_tamanho found in the JSON or from subitem
        valor: subitem.pedidoItemQuantidade,
      };
      console.log('NEW ITEM', newItem);
      this.items.push(newItem);
    });
  },
  methods: {
    removeItem(index, item) {
      this.items.splice(index, 1);
      this.$emit('remove-item', item);
    },
    sizeLabel(size) {
      return descricaoTamanhoGrade(this.gradeColorSelecionada, size, this.tamanhosMap);
    },
    getAvailableSizes(color) {
      const sizes = [];
      if (color.itemExtrapq) sizes.push('Extrapq');
      if (color.itemPequeno) sizes.push('Pequeno');
      if (color.itemMedio) sizes.push('Medio');
      if (color.itemGrande) sizes.push('Grande');
      if (color.itemExtraGd) sizes.push('ExtraGd');
      if (color.itemSuperGd) sizes.push('SuperGd');
      if (color.itemUltraGd) sizes.push('UltraGd');
      if (color.itemUnico) sizes.push('Unico');
      if (color.itemOutros) sizes.push('Outros');
      return sizes;
    },
    selectEmbalagem(embalagem) {
      console.log('SELECTED EMBALAGEM', embalagem);
      this.formColor.embalagem = embalagem.descricao_embalagem;
      this.formColor.cdn_embalagem = embalagem.cdn_embalagem;
      this.availableColors = embalagem.grade;
      this.availableSizes = [];
    },
    selectColor(color) {
      console.log('SELECTED COLOR', color);
      this.formColor.color = color.desCor;
      this.formColor.tamanho = '';
      this.formColor.quantidade = 0;
      this.gradeColorSelecionada = color;
      this.availableSizes = this.getAvailableSizes(color);
    },
    repeateAgain() {
      console.log('embalagem', this.formColor.embalagem);
      console.log('color', this.formColor.color);
      console.log('tamanho', this.formColor.tamanho);
      console.log('quantidade', this.formColor.quantidade);
      if (!this.formColor.color || !this.formColor.tamanho || !this.formColor.quantidade) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Falha',
            text: 'Obrigatorio Selecionar: Cor, Tamanho e Quantidade.',
            icon: 'CheckIcon',
            variant: 'danger',
          },
        });
        return;
      }

      const embalagem = this.json.embalagens.find((item) => item.descricao_embalagem === this.formColor.embalagem);

      // Encontre a cor correspondente no JSON
      const foundColor = embalagem.grade.find((item) => item.desCor === this.formColor.color);
      const foundSize = embalagem.grade.find((item) => item.desCor === this.formColor.color);

      if (!foundColor) {
        alert('Color not found in JSON.');
        return;
      }
      console.log(this.json.subItens);
      // Crie o novo item
      const newItem = {
        referencia: this.json.subItens[0].familiaComercialId,
        nome: this.json.subItens[0].descricao_referencia,
        preco: this.json.subItens[0].precoUnitario,
        marca: this.json.subItens[0].marca,
        embalagem: this.formColor.embalagem,
        cdn_embalagem: this.formColor.cdn_embalagem,
        des_cor: this.formColor.color,
        cdn_cor: foundColor.cdnCor, // Use o cdnCor encontrado no JSON
        tamanho: this.formColor.tamanho,
        item_id: foundSize[`item${this.formColor.tamanho}`], // Use o cdn_tamanho encontrado no JSON
        valor: this.formColor.quantidade,
      };

      this.items.push(newItem);

      console.log('ITEMS ENVIADO DA PRA GRADE', this.items);
      this.$emit('update:grade', this.items);

      this.formColor.quantidade = 0;
      this.formColor.tamanho = '';
      this.formColor.color = '';
      this.availableSizes = [];
    },
  },
};
</script>
<style scoped>
.imagens-container {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.imagens-item-img img {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.loading-indicator {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  justify-content: center; /* Centraliza o spinner no celular */
}

.product-color-options h6 {
  font-size: 16px;
  font-weight: 600;
}

/* Ajuste de colunas para telas menores */
@media (max-width: 768px) {
  .imagens-container {
    flex-direction: row;
    justify-content: center;
  }

  .imagens-item-img img {
    width: 50px;
    height: 50px;
  }

  /* Mantém rolagem horizontal para listas com muitas opções */
  .product-color-options .scrollable-pills {
    flex-direction: row;
    flex-wrap: nowrap;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }

  .product-color-options ul li {
    width: 100%;
    text-align: center;
  }

  .product-color-options h6 {
    text-align: center;
  }

  .ecommerce-details-item_price {
    justify-content: center;
  }

  .item-item_price {
    text-align: center;
    width: 100%;
  }

  .col-md-6 {
    text-align: center;
  }
}

/* Scroll horizontal suave para pílulas */
.scrollable-pills {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 6px;
  scroll-snap-type: x proximity;
}
.scrollable-pills li {
  flex: 0 0 auto;
  scroll-snap-align: start;
}
.scrollable-pills::-webkit-scrollbar {
  height: 6px;
}
.scrollable-pills::-webkit-scrollbar-thumb {
  background-color: rgba(0,0,0,0.2);
  border-radius: 3px;
}
</style>
